import { usDate } from '@sly/core/helpers/date';
import { jsonLdStringify } from '@sly/core/helpers/strings';
import { stringifyReplacer } from '@sly/frontend/common/helpers/html_headers';
import React from 'react';

function AgentSeo({ agent }) {
  const getPersonSchema = (agent) => {
    const { info } = agent;
    const {
      company,
      education,
      licenses,
      advisoryWorks,
      certificates,
      assetInfo,
      knowsAbout,
      displayName,
    } = info || {};

    const ld = {};
    ld['@context'] = 'https://schema.org';
    ld['@type'] = 'Person';
    ld.name = displayName;

    if (company) {
      ld['worksFor'] = {
        '@type': 'Organization',
        name: company,
      };
    }

    if (
      !!education?.length ||
      !!licenses?.length ||
      !!advisoryWorks?.length ||
      !!certificates?.length ||
      !!knowsAbout?.length
    ) {
      ld['hasCredential'] = [];
      if (education?.length) {
        ld['alumniOf'] = [];
        education.forEach((educationItem) => {
          if (educationItem.instituteName) {
            ld['alumniOf'].push({
              '@type': 'CollegeOrUniversity',
              name: educationItem.instituteName,
            });
          }
          if (educationItem.degree) {
            const item = {
              '@type': 'EducationalOccupationalCredential',
              credentialCategory: 'degree',
              name: educationItem.degree,
            };
            if (educationItem.advancedDegree) {
              item['educationalLevel'] = 'advanced';
            }
            ld['hasCredential'].push(item);
          }
        });
      }

      if (advisoryWorks?.length) {
        ld['memberOf'] = [];
        advisoryWorks.map((item) => {
          if (item.advisoryWorkName) {
            ld['memberOf'].push({
              '@type': 'Organization',
              name: item.advisoryWorkName,
            });
          }
        });
      }

      if (licenses?.length) {
        licenses.forEach((licenseItem) => {
          if (licenseItem.licenseName) {
            ld['hasCredential'].push({
              '@type': 'EducationalOccupationalCredential',
              credentialCategory: 'license',
              name: licenseItem.licenseName,
            });
          }
        });
      }

      if (certificates?.length) {
        certificates.forEach((certificate) => {
          if (certificate.certificateName) {
            const item = {
              '@type': 'EducationalOccupationalCredential',
              credentialCategory: 'certificate',
            };
            if (certificate.issuedDate) {
              item.dateCreated = usDate(certificate.issuedDate);
            }
            if (certificate.certificateName) {
              item.name = certificate.certificateName;
              ld['hasCredential'].push(item);
            }
          }
        });
      }

      if (knowsAbout?.length) {
        knowsAbout.forEach((item) => {
          if (item.title) {
            let knowsAboutItem = {
              '@type': 'Thing',
              name: item.title,
            };
            if (!ld['knowsAbout']) {
              ld['knowsAbout'] = [knowsAboutItem];
            } else {
              ld['knowsAbout'].push(knowsAboutItem);
            }
          }
        });
      }
    }

    if (assetInfo?.assets?.linkedIn?.info) {
      ld['@sameAs'] = assetInfo?.assets?.linkedIn?.info;
    }

    return ld;
  };
  return (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{
        __html: jsonLdStringify(getPersonSchema(agent), stringifyReplacer),
      }}
    />
  );
}

export default AgentSeo;
